import _extends from "@babel/runtime/helpers/extends";
import { useFloating } from "@floating-ui/react";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useOutsideClick } from "../../shared";
import { tombac } from "../../shared/tombac";
import { Button } from "../Button";
export const NavbarCollapse = _ref => {
  let {
    breakpoint = 768,
    children,
    ...rest
  } = _ref;
  const [isOpen, setIsOpen] = useState(false);
  const {
    x,
    y,
    refs,
    strategy,
    update
  } = useFloating({
    middleware: [{
      name: "zeroXOffset",
      fn: () => ({
        x: 0
      })
    }],
    placement: "bottom-start"
  });
  useEffect(() => {
    if (isOpen) {
      update();
    }
  }, [isOpen, update]);
  useOutsideClick(refs.domReference.current, () => setIsOpen(false));
  return /*#__PURE__*/React.createElement(Container, _extends({
    ref: refs.setReference
  }, rest), /*#__PURE__*/React.createElement(Children, {
    breakpoint: breakpoint
  }, children), /*#__PURE__*/React.createElement(ExpandButton, {
    "aria-label": isOpen ? "Collapse menu" : "Show menu",
    breakpoint: breakpoint,
    onClick: () => setIsOpen(isOpen => !isOpen),
    shape: "circle",
    variant: "flat"
  }, /*#__PURE__*/React.createElement(HamburgerIcon, {
    "aria-hidden": true
  })), /*#__PURE__*/React.createElement(Menu, {
    breakpoint: breakpoint,
    isOpen: isOpen,
    onClick: () => setIsOpen(false),
    ref: refs.setFloating,
    style: {
      position: strategy,
      top: y !== null && y !== void 0 ? y : 0,
      left: x !== null && x !== void 0 ? x : 0
    }
  }, /*#__PURE__*/React.createElement(MenuInner, {
    breakpoint: breakpoint,
    isOpen: isOpen
  }, children)));
};
const Children = styled.div.withConfig({
  displayName: "NavbarCollapse__Children"
})(["align-items:center;align-self:stretch;background:", ";display:flex;flex:auto;@media (max-width:", "){box-shadow:0 ", " 0 hsla(0,0%,0%,0.04);left:0;overflow:hidden;position:fixed;right:0;top:100%;transition:max-height 0.1s ease-out;}"], tombac.color.white, _ref2 => {
  let {
    breakpoint
  } = _ref2;
  return tombac.unit(breakpoint);
}, tombac.unit(2, 8));
const Container = styled.div.withConfig({
  displayName: "NavbarCollapse__Container"
})(["align-self:stretch;display:flex;flex:auto;"]);
const HamburgerIcon = styled(props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "4 -4 16 24",
  height: "24",
  width: "24"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M4 14h16v-2H4zm0-5h16V7H4zm0-5h16V2H4z",
  fill: "currentColor"
}))).withConfig({
  displayName: "NavbarCollapse__HamburgerIcon"
})(["display:block;"]);
const ExpandButton = styled(Button).withConfig({
  displayName: "NavbarCollapse__ExpandButton"
})(["align-self:center;display:none;margin-left:auto;margin-right:", ";@media (max-width:", "){display:flex;}"], tombac.space(2), _ref3 => {
  let {
    breakpoint
  } = _ref3;
  return tombac.unit(breakpoint);
});
const Menu = styled.div.withConfig({
  displayName: "NavbarCollapse__Menu"
})(["display:none;overflow:hidden;padding-bottom:", ";position:relative;width:100%;&::after{box-shadow:inset 0 ", " hsla(0,0%,0%,0.04);content:\"\";height:", ";opacity:", ";position:absolute;top:0;transition:opacity 0.1s ease-out;visibility:", ";width:100%;}@media (max-width:", "){display:block;}"], tombac.unit(8), tombac.unit(10, 8, -8), tombac.unit(8), _ref4 => {
  let {
    isOpen
  } = _ref4;
  return isOpen ? 1 : 0;
}, _ref5 => {
  let {
    isOpen
  } = _ref5;
  return isOpen ? "visible" : "hidden";
}, _ref6 => {
  let {
    breakpoint
  } = _ref6;
  return tombac.unit(breakpoint);
});
const MenuInner = styled.div.withConfig({
  displayName: "NavbarCollapse__MenuInner"
})(["background-color:", ";opacity:", ";transform:translate(0,", ");transition:0.1s ease-out;transition-property:opacity,transform;visibility:visible;&::after{bottom:", ";box-shadow:inset 0 ", " hsla(0,0%,0%,0.04);content:\"\";height:", ";opacity:", ";position:absolute;transition:opacity 0.1s ease-out;visibility:", ";width:100%;}"], tombac.color.white, _ref7 => {
  let {
    isOpen
  } = _ref7;
  return isOpen ? 1 : 0;
}, _ref8 => {
  let {
    isOpen
  } = _ref8;
  return isOpen ? "0" : "-100%";
}, tombac.unit(-8), tombac.unit(10, 8, -8), tombac.unit(8), _ref9 => {
  let {
    isOpen
  } = _ref9;
  return isOpen ? 1 : 0;
}, _ref10 => {
  let {
    isOpen
  } = _ref10;
  return isOpen ? "visible" : "hidden";
});
//# sourceMappingURL=NavbarCollapse.js.map